// useAutoSaveQuiz.js
import { useEffect } from "react";
import CONFIG from "../config/config";

const useAutoSaveQuiz = (quizId, quizStructure) => {
  const token = localStorage.getItem("token");
  useEffect(() => {
    const saveDraft = async () => {
      try {
        await fetch(`${CONFIG.API_URL}/quiz/${quizId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
          body: JSON.stringify({ structure: quizStructure }),
        });
      } catch (error) {
        console.error('Error saving draft:', error);
      }
    };

    if (quizId) saveDraft();
  }, [quizId, quizStructure]);
};

export default useAutoSaveQuiz;